import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LeadProvider } from "./Context/LeadContext";

import Layout from "./Components/Layout/Layout";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Carriers from "./Pages/Carriers/Carriers";
import Faqs from "./Pages/Faqs/Faqs";
import Quote from "./Pages/Quote/Quote";
import BlogList from "./Pages/Blog/BlogList";
import BlogArticle from "./Pages/Blog/BlogArticle";
import AgentProfile from "./Pages/Agent/AgentProfile";
import AgentSearch from "./Pages/Agent/AgentSearch";
import NotFound404 from "./Pages/Errors/NotFound404";
import VSQuote from "./Pages/Quote/vsQuote";

function App() {
  return (
    <LeadProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="carriers" element={<Carriers />} />
            <Route path="faqs" element={<Faqs />} />

            <Route path="quote" element={<VSQuote />} />

            <Route path="blog" element={<BlogList />} />
            <Route path="blog/:slug" element={<BlogArticle />} />

            <Route path="agent" element={<AgentSearch />} />
            <Route path="agent/:slug" element={<AgentProfile />} />
            <Route path="*" element={<NotFound404 reason="route" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LeadProvider>
  );
}

export default App;
